import { Form, Field, TextInput, Dropdown } from '@carboledger/ui';
import { useTranslations } from '@/hooks';
import { declarationValidation } from '../../declarationsValidation';

/**
 * Props:
 *   formOptions  useValidateDeclarationFormOptions() result
 */
export const ComplianceContextSection = ({ formOptions }) => {
  const t = useTranslations();

  return (
    <Form.Section title={t('SECTION_GENERAL_INFORMATION')}>
      <Form.Row columns={2}>
        <Field name="energyContent" required rules={declarationValidation.energyContent}>
          {({ id, name, value, onChange, onBlur, status, message, required }) => (
            <TextInput
              id={id}
              name={name}
              label={t('FIELD_ENERGY_CONTENT')}
              placeholder={t('FORM_ENERGY_CONTENT_PLACEHOLDER')}
              value={value}
              onChange={onChange}
              onBlur={onBlur}
              status={status}
              message={message}
              required={required}
            />
          )}
        </Field>

        <Field name="euRedCompliantMaterial" required>
          {({ id, name, value, onChange, onBlur, status, message, required }) => (
            <Dropdown
              id={id}
              name={name}
              label={t('FIELD_EU_RED_COMPLIANT_MATERIAL')}
              placeholder={t('COMMON_SELECT')}
              value={value}
              onChange={onChange}
              onBlur={onBlur}
              status={status}
              message={message}
              required={required}
              options={formOptions.yesNoOptions}
            />
          )}
        </Field>
      </Form.Row>

      <Form.Row columns={2}>
        <Field name="isccCompliantMaterial">
          {({ id, name, value, onChange, onBlur, status, message }) => (
            <Dropdown
              id={id}
              name={name}
              label={t('FORM_ISCC_COMPLIANT_MATERIAL')}
              placeholder={t('COMMON_SELECT')}
              value={value}
              onChange={onChange}
              onBlur={onBlur}
              status={status}
              message={message}
              options={formOptions.yesNoOptions}
            />
          )}
        </Field>

        <Field name="chainOfCustodyOption">
          {({ id, name, value, onChange, onBlur, status, message }) => (
            <Dropdown
              id={id}
              name={name}
              label={t('FORM_CHAIN_OF_CUSTODY_OPTION')}
              placeholder={t('COMMON_SELECT')}
              value={value}
              onChange={onChange}
              onBlur={onBlur}
              status={status}
              message={message}
              options={formOptions.chainOfCustodyOptions}
            />
          )}
        </Field>
      </Form.Row>

      <Form.Row columns={2}>
        <Field name="countryOfBiofuelProduction" required>
          {({ id, name, value, onChange, onBlur, status, message, required }) => (
            <Dropdown
              id={id}
              name={name}
              label={t('FIELD_COUNTRY_OF_BIOFUEL_PRODUCTION')}
              placeholder={t('COMMON_SELECT')}
              value={value}
              onChange={onChange}
              onBlur={onBlur}
              status={status}
              message={message}
              required={required}
              options={formOptions.countryOptions}
              searchable
            />
          )}
        </Field>

        <Field name="startDateOfBiofuelProduction" required>
          {({ id, name, value, onChange, onBlur, status, message, required }) => (
            <TextInput
              id={id}
              name={name}
              // TODO: swap for a DatePicker when the library has one.
              type="date"
              label={t('FIELD_START_DATE_OF_BIOFUEL_PRODUCTION')}
              value={value}
              onChange={onChange}
              onBlur={onBlur}
              status={status}
              message={message}
              required={required}
            />
          )}
        </Field>
      </Form.Row>

      <Form.Row columns={2}>
        <Field name="startDateOfBioliquidUse">
          {({ id, name, value, onChange, onBlur, status, message }) => (
            <TextInput
              id={id}
              name={name}
              type="date"
              label={t('FORM_START_DATE_OF_BIOLIQUID_USE')}
              value={value}
              onChange={onChange}
              onBlur={onBlur}
              status={status}
              message={message}
            />
          )}
        </Field>
      </Form.Row>
    </Form.Section>
  );
};
